// src/slices/companygps/thunk.js
import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const API_URL = process.env.REACT_APP_API_URL;

/* =========================
   GET ALL COMPANY GPS
========================= */
export const getCompanyGps = createAsyncThunk("companyGps/getAll", async (payload = {}, { rejectWithValue }) => {
  try {
    let params = {};

    if (typeof payload === "object") {
      if (payload.type !== undefined) {
        params.type = payload.type;
      }

      if (payload.categoryId !== undefined && payload.categoryId !== null) {
        params.categoryId = payload.categoryId;
      }

      if (payload.governorate !== undefined && payload.governorate !== "") {
        params.governorate = payload.governorate;
      }

      if (payload.page !== undefined) {
        params.page = payload.page;
      }

      if (payload.limit !== undefined) {
        params.limit = payload.limit;
      }
    } else {
      params.categoryId = payload;
    }

    const response = await axios.get(`${API_URL}/company-gps/all`, { params });

    return response.data.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const getCompanyGpsCategories = createAsyncThunk("companyGps/getCategories", async ({ page = 1, limit = 10, search = "", gps = "" }, { rejectWithValue }) => {
  try {
    const authUser = JSON.parse(sessionStorage.getItem("authUser"));
    const token = authUser?.data?.token?.replace("Bearer ", "");

    const response = await axios.get(`${API_URL}/company-gps/categories`, { params: { page, limit, search, gps }, headers: { Authorization: `Bearer ${token}` } });
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || "Something went wrong");
  }
});
export const getCompanyGpsBySlug = createAsyncThunk("companyGps/getBySlug", async ({ identifier, page = 1, limit = 10 }, { rejectWithValue }) => {
  try {
    const response = await axios.get(`${API_URL}/company-gps/one`, { params: { identifier, page, limit } });

    return response.data;
  } catch (err) {
    return rejectWithValue(err.response?.data || err.message);
  }
});

export const createCompanyGpsFromUser = createAsyncThunk("companyGps/createFromUser", async (payload, { rejectWithValue }) => {
  try {
    const authUser = JSON.parse(sessionStorage.getItem("authUser"));
    const token = authUser?.data?.token?.replace("Bearer ", "");

    const response = await axios.post(`${API_URL}/company-gps/from-user`, payload, { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } });

    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || error.message);
  }
});
